import axios from 'axios';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';

function hasRateLimitError(thrown: ThrownType) {
  return thrown.response && thrown.response.status === 429;
}

function hasTooLongQueryError(thrown: ThrownType) {
  return (
    thrown.response &&
    thrown.response.status === 422 &&
    thrown.response.data.error === 'TOO_LONG_QUERY'
  );
}

function hasQuotaExceededError(thrown: ThrownType) {
  return (
    thrown.response &&
    thrown.response.data &&
    thrown.response.data.error === 'SEARCH_QUOTA_EXCEEDED'
  );
}

function hasHeaderFieldsTooLargeError(thrownResponse: ThrownTypeResponse) {
  return thrownResponse.status === 431;
}

export function getSearchErrorData(
  thrownResponse: ThrownTypeResponse,
): ThrownTypeResponse {
  if (hasHeaderFieldsTooLargeError(thrownResponse)) {
    doctrineAnalytics('Search RequestFieldsTooLarge');
    return { data: { error: 'HEADER_FIELDS_TOO_LARGE' } };
  }
  return thrownResponse;
}

export function shouldReportError(thrown: ThrownType) {
  const isQuotaExceededError = hasQuotaExceededError(thrown);
  const isRateLimitError = hasRateLimitError(thrown);
  const isTooLongQueryError = hasTooLongQueryError(thrown);
  const isHeaderFieldsTooLargeError =
    thrown.response && hasHeaderFieldsTooLargeError(thrown.response);
  return (
    !axios.isCancel(thrown) &&
    !isRateLimitError &&
    !isQuotaExceededError &&
    !isTooLongQueryError &&
    !isHeaderFieldsTooLargeError
  );
}
